import { Link } from 'react-router-dom';
import { useBaseUrlStore, useLabels } from 'src/StoreDataProvider';
import CustomLink from '../CustomLink';
import { CustomLinkType } from '../CustomLink/customLink.types';
import LanguageSpan from '../LanguageSpan';
import { CrossLinkProps } from './crossLink.types';

const CrossLink: (props: CrossLinkProps) => JSX.Element = ({
  id,
  titel,
  photo,
}) => {
  const labels = useLabels();
  const { path } = useBaseUrlStore();

  return (
    <div key={id} className="column">
      <div className="fade">
        <Link tabIndex={-1} to={`/${path}/detail/${id}`} aria-hidden="true">
          <img
            className="single-img"
            src={photo?.imageSrc && 'data:image/jpg;base64,' + photo?.imageSrc}
            alt={photo?.imageAlt}
          />
        </Link>
        <Link className="crosslinks__projectName" to={`/${path}/detail/${id}`}>
          <div className="crosslinks__projectName__link">
            <LanguageSpan
              text={titel}
              keyPrefix={`projectName-${id}`}
            ></LanguageSpan>
          </div>
        </Link>
        <CustomLink
          tabIndex={-1}
          aria-hidden="true"
          className="link"
          label={labels.readNow}
          type={CustomLinkType.nav}
          to={`/${path}/detail/${id}`}
          icon={'icon-pfeil-rechts'}
        />
      </div>
    </div>
  );
};

export default CrossLink;
